import { z } from 'zod';
export const entryNameSchema = z
    .string()
    .min(1)
    .max(240)
    .refine((name) => !/[\p{Cc}\p{Cf}]/u.test(name), 'Use a name without control characters')
    .transform((name) => name.normalize('NFKC').trim().replace(/\s+/gu, ' '))
    .pipe(z.string().min(1).max(80));
export const sharedPinSchema = z.string().regex(/^[0-9]{6}$/);
export const formationKeySchema = z
    .string()
    .min(16)
    .max(100)
    .regex(/^[a-zA-Z0-9_-]+$/);
export const requestTeamSchema = z
    .object({
    name: entryNameSchema,
    pin: sharedPinSchema,
    confirmPin: sharedPinSchema,
    idempotencyKey: formationKeySchema,
})
    .strict()
    .refine((v) => v.pin === v.confirmPin, { message: 'PINs must match', path: ['confirmPin'] });
export const resumeRequestSchema = z
    .object({
    name: entryNameSchema,
    pin: sharedPinSchema,
    requestId: formationKeySchema.optional(),
})
    .strict();
export const approvedTeamLoginSchema = z
    .object({ name: entryNameSchema, pin: sharedPinSchema })
    .strict();
export const revokeTeamAccessSchema = z
    .object({ expectedVersion: z.number().int().nonnegative(), idempotencyKey: formationKeySchema })
    .strict();
export const decideRequestSchema = z
    .object({
    action: z.enum(['APPROVE', 'REJECT']),
    expectedVersion: z.number().int().nonnegative(),
    idempotencyKey: formationKeySchema,
})
    .strict();
export const resetRequestPinSchema = z
    .object({
    pin: sharedPinSchema,
    confirmPin: sharedPinSchema,
    expectedVersion: z.number().int().nonnegative(),
    idempotencyKey: formationKeySchema,
})
    .strict()
    .refine((v) => v.pin === v.confirmPin, { message: 'PINs must match', path: ['confirmPin'] });
export const requestStatusSchema = z.object({
    requestId: formationKeySchema,
    name: z.string(),
    status: z.enum(['PENDING', 'APPROVED', 'REJECTED']),
    version: z.number().int(),
    createdAt: z.string().datetime(),
    decidedAt: z.string().datetime().optional(),
    accessRevoked: z.boolean().optional(),
});
export const ownRequestSchema = z.object({
    request: requestStatusSchema,
    formationOpen: z.boolean(),
});
export const formationQueueSchema = z.object({
    requests: z.array(requestStatusSchema),
    formationOpen: z.boolean(),
    cursor: z.string().optional(),
});
export const approvedTeamChoicesSchema = z.object({
    teams: z.array(z.object({ name: z.string() })),
    cursor: z.string().optional(),
});
//# sourceMappingURL=formation.js.map